export class CandidateEducationClass {
    id?: number;
    school?: string[];
    field?: string;
}
